import { useEffect, useState } from 'react';
import { serverNow } from '@/lib/serverClock';

/**
 * Current time on the SERVER's clock (calibrated from the live stream's
 * `ready` frame). Countdowns compare against server timestamps
 * (`deadline_at`, `waiting_since`), so a salon PC whose clock is off must not
 * shift them.
 *
 * The time is read on every render — a component that just switched into a
 * ticking state (e.g. "Kunde wartet") shows the right value on its very first
 * frame. The interval (only while `enabled`) merely re-renders every
 * `intervalMs`.
 */
export function useServerNow(intervalMs: number, enabled = true): number {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(() => setTick((n) => n + 1), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, enabled]);

  return serverNow();
}

export default useServerNow;
